/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import ReactDatepicker from "react-datepicker";
import cn from "classnames";
import { addYears, parseISO } from "date-fns";
import { format } from "date-fns-tz";

import styles from "./datepicker.module.css";
import { ButtonGroup } from "src/components/ui-components/ButtonOld/ButtonGroup";

interface DatepickerProps {
  disabled?: boolean;
  id?: string;
  kind: "dialog" | "parameter";
  onChange: (event: any) => void;
  placeholder?: string;
  required: boolean;
  value: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  wrapperClassNameOverride?: string;
  customInput?: React.ReactNode;
}

const MAX_DATE = addYears(new Date(), 10);
const MIN_DATE = new Date("2008-01-01T00:00");

export const Datepicker: React.FC<DatepickerProps> = (props) => {
  const datepickerRef = React.useRef<ReactDatepicker>(null);
  const [pickerValue, setPickerValue] = React.useState<Date | undefined>(
    props.value ? parseISO(props.value) : undefined
  );

  const wrapperClassName =
    props.wrapperClassNameOverride ??
    cn(styles.datepicker, props.kind === "parameter" && styles.parameter);

  const clearDatepicker = (e: React.MouseEvent) => {
    e.preventDefault();
    setPickerValue(undefined);
  };

  const closeDatepicker = (e: React.MouseEvent) => {
    e.preventDefault();
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(false);
    }
  };

  const handleChange = (date: Date) => {
    setPickerValue(date);

    if (date) {
      const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss");
      props.onChange(formattedDate);
    }
  };

  return (
    <ReactDatepicker
      id={props.id}
      portalId={props.kind === "dialog" ? "" : "portal"}
      dateFormat="yyyy-MM-dd HH:mm:ss"
      disabled={props.disabled}
      dropdownMode="select"
      maxDate={MAX_DATE}
      minDate={MIN_DATE}
      onChange={handleChange}
      peekNextMonth
      placeholderText={props.placeholder ?? "yyyy-mm-dd hh:mm:ss"}
      popperClassName={styles.popper}
      ref={datepickerRef}
      required={props.required}
      selected={pickerValue}
      showMonthDropdown
      showTimeInput={true}
      showYearDropdown
      timeFormat="HH:mm"
      timeInputLabel="Time:"
      wrapperClassName={wrapperClassName}
      onKeyDown={props.onKeyDown}
      customInput={props.customInput}
    >
      <ButtonGroup className={styles["button-group"]} right>
        <a className={styles["button-secondary"]} onClick={clearDatepicker}>
          Clear
        </a>
        <a className={styles["button-primary"]} onClick={closeDatepicker}>
          Done
        </a>
      </ButtonGroup>
    </ReactDatepicker>
  );
};
